var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitterIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 29,
    viewBox: "0 0 33 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.563 5.24112C30.443 5.72645 29.2857 6.06245 28.0537 6.21179C29.323 5.46512 30.2937 4.27046 30.7417 2.81446C29.547 3.52379 28.2403 4.00912 26.859 4.30779C25.739 3.11312 24.1336 2.36646 22.379 2.36646C18.9816 2.36646 16.2563 5.12912 16.2563 8.48912C16.2563 8.97446 16.2936 9.42245 16.4056 9.87045C11.3283 9.64645 6.8483 7.18245 3.82429 3.48645C1.65896 7.36912 4.08563 10.5798 5.69096 11.6625C4.72029 11.6625 3.74962 11.3638 2.92829 10.9158C2.92829 13.9398 5.05629 16.4411 7.81896 17.0011C7.22163 17.1878 5.87763 17.2998 5.05629 17.1131C5.84029 19.5398 8.11763 21.3318 10.7683 21.3691C8.67763 23.0118 5.61629 24.3185 1.69629 23.9078C4.42163 25.6625 7.6323 26.6705 11.1043 26.6705C22.379 26.6705 28.5017 17.3371 28.5017 9.27312C28.5017 9.01179 28.5017 8.75046 28.4643 8.48912C29.7337 7.55579 30.779 6.47312 31.563 5.24112Z",
    fill: "#ED3E3E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterIcon);
export default __webpack_public_path__ + "static/media/twitter_icon.6fc4c9074fc7e8d025d011a35c2edaa5.svg";
export { ForwardRef as ReactComponent };